import React from 'react';

export default function MundBotConversa() {
  return (
    <svg
      width='88'
      height='56'
      viewBox='0 0 88 56'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_3901_80323)'>
        <rect
          x='3.50488'
          y='13.8578'
          width='40'
          height='40'
          rx='10'
          transform='rotate(-15 3.50488 13.8578)'
          fill='url(#paint0_linear_3901_80323)'
        />
        <g clip-path='url(#clip1_3901_80323)'>
          <path
            d='M26.0782 15.3202L25.2322 16.5812C25.1136 16.7583 24.8855 16.8194 24.6942 16.7253L23.3277 16.0524C23.2183 15.9983 23.0886 15.9925 22.9776 16.039C22.2987 16.321 21.6254 16.6682 20.9644 17.0789C17.4743 19.2485 15.2675 23.0547 15.1143 27.1758C14.8342 34.8436 20.5852 40.395 27.1835 40.829C28.543 40.9176 29.9398 40.7911 31.3277 40.4192C32.7157 40.0473 33.9886 39.4584 35.1217 38.702C39.5809 35.7222 41.8726 30.0987 40.4028 24.6132C38.7155 18.3162 32.6423 14.343 26.374 15.1313C26.2525 15.1472 26.1425 15.2148 26.0732 15.3191L26.0782 15.3202ZM18.1565 31.7824L18.1581 31.7795L21.9767 30.7564C22.1772 30.8671 22.294 30.9311 22.4923 31.0424C23.3437 33.6622 24.4822 35.8833 25.7497 37.5145C25.9995 37.8361 25.7041 38.2918 25.3113 38.1897C22.1249 37.3395 19.4058 35.0104 18.1527 31.7858L18.1565 31.7824ZM30.803 38.16C30.7771 38.1693 30.7527 38.1758 30.7284 38.1824C30.704 38.1889 30.6797 38.1954 30.6525 38.2003C29.2126 38.467 26.475 35.7235 24.736 30.4817C24.6595 30.2496 24.7941 29.9991 25.0287 29.9362L31.5413 28.1911C31.776 28.1283 32.0177 28.278 32.0676 28.5172C33.1824 33.9262 32.1811 37.6716 30.803 38.16ZM35.4211 35.4808C35.1348 35.7672 34.6505 35.518 34.7039 35.1153C34.9992 32.9675 34.8453 30.3301 34.1989 27.4838C34.1983 27.4816 34.2005 27.481 34.2005 27.481L33.7102 25.651C33.6494 25.4242 33.4162 25.2889 33.1904 25.3494L18.0246 29.4131C17.7701 29.4813 17.5199 29.3004 17.4919 29.0363C17.1486 25.7894 18.3299 22.6274 20.5518 20.4091C20.8402 20.1221 21.323 20.374 21.2679 20.7796C21.0627 22.2717 21.0753 24.0009 21.3167 25.8761C21.3491 26.1296 21.6028 26.2975 21.8486 26.2317L23.2675 25.8515C23.4712 25.7969 23.6027 25.5972 23.5773 25.3871C23.0534 21.0591 23.9675 18.1569 25.1698 17.7299L25.3182 17.6901C26.573 17.4588 28.8178 19.5145 30.526 23.5253C30.609 23.7199 30.8205 23.8276 31.0264 23.7725L32.4431 23.3929C32.6889 23.327 32.8253 23.0569 32.7259 22.819C32.0025 21.0753 31.1465 19.5721 30.2244 18.3798C29.9745 18.0582 30.2682 17.5959 30.6593 17.7008C33.8379 18.5483 36.5496 20.8674 37.807 24.0814C37.8118 24.0992 37.8188 24.1164 37.8235 24.1342L38.4104 26.3244C38.4152 26.3421 38.4199 26.3599 38.4225 26.3783C38.9405 29.7904 37.7495 33.1553 35.4205 35.4785L35.4211 35.4808Z'
            fill='url(#paint1_linear_3901_80323)'
          />
        </g>
      </g>
      <g clip-path='url(#clip2_3901_80323)'>
        <path
          d='M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z'
          fill='url(#paint2_linear_3901_80323)'
        />
        <path
          d='M48.603 27.1789C49.8972 22.3489 54.8618 19.4826 59.6919 20.7769L66.3204 22.5529C71.1504 23.8472 74.0169 28.8117 72.7227 33.6417C71.4285 38.4716 66.4638 41.3379 61.6337 40.0437L55.0053 38.2676C50.1752 36.9734 47.3088 32.0088 48.603 27.1789Z'
          fill='#3868C7'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M52.7284 11.8168C54.0826 12.1797 54.8863 13.5716 54.5235 14.9258L51.0632 27.8395L48.6112 27.1825L46.1591 26.5255L49.6194 13.6118C49.9822 12.2576 51.3742 11.4539 52.7284 11.8168Z'
          fill='#76C451'
        />
        <path
          d='M60.0576 30.25C59.6948 31.6042 58.3146 32.411 56.9749 32.052C55.6352 31.6931 54.8434 30.3043 55.2063 28.9501C55.5691 27.5959 56.9493 26.789 58.2889 27.148C59.6286 27.507 60.4205 28.8958 60.0576 30.25Z'
          fill='white'
        />
        <path
          d='M67.7373 32.3077C67.3745 33.6619 65.9942 34.4687 64.6546 34.1098C63.3149 33.7508 62.5231 32.362 62.886 31.0078C63.2488 29.6536 64.6289 28.8468 65.9686 29.2057C67.3083 29.5647 68.1002 30.9535 67.7373 32.3077Z'
          fill='white'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M46.1589 26.5254C47.8154 20.343 54.1679 16.6701 60.3504 18.3267L61.6647 18.6788C63.0188 19.0417 63.8225 20.4336 63.4596 21.7878C63.0968 23.142 61.7048 23.9457 60.3506 23.5828L59.0364 23.2307C55.5658 22.3007 51.9947 24.362 51.063 27.8394C50.1312 31.3169 52.1932 34.8874 55.6638 35.8174L62.0183 37.5201C63.3726 37.8829 64.1762 39.2749 63.8134 40.6291C63.4505 41.9833 62.0585 42.787 60.7043 42.4241L54.3497 40.7214C48.1673 39.0648 44.5023 32.7077 46.1589 26.5254Z'
          fill='#76C451'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3901_80323'
          x1='23.5049'
          y1='13.8578'
          x2='23.5049'
          y2='53.8578'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3901_80323'
          x1='10.6936'
          y1='13.8569'
          x2='35.8057'
          y2='35.4541'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3901_80323'
          x1='65.1759'
          y1='8.68151'
          x2='54.8232'
          y2='47.3185'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#2B3238' />
          <stop offset='1' stop-color='#202D39' />
        </linearGradient>
        <clipPath id='clip0_3901_80323'>
          <rect
            x='3.50488'
            y='13.8578'
            width='40'
            height='40'
            rx='10'
            transform='rotate(-15 3.50488 13.8578)'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip1_3901_80323'>
          <rect
            width='30'
            height='30'
            fill='white'
            transform='translate(9.62891 17.3935) rotate(-15)'
          />
        </clipPath>
        <clipPath id='clip2_3901_80323'>
          <path
            d='M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
